import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { Observable } from 'rxjs';
import { ILocalStorageServiceToken } from 'shared/services/infrastructure/localstorage/localstorage-service.interface';

@Injectable({
  providedIn: 'root'
})
export class AgeVerificationInterceptorGuard {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return ServiceLocator.injector.get(ILocalStorageServiceToken).ageVerificationAcceptanceGet();
  }
}
